import React, { useState } from 'react'
import { Button, Modal } from 'antd'
import fandasturi from '../Components/fayl/meyoriy/fandasturi.pdf'
import fansillabus from '../Components/fayl/meyoriy/fansillabus.pdf'




export const Meyoriy = () => {
    const [isModalOpen, setIsModalOpen] =useState(false);
    const showModal =() => {
        setIsModalOpen(true);

    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
  return (
    <div className='card'><Button className='button' onClick={showModal}> Me'yoriy xujjatlar</Button> 
    <Modal className='custom-modal' open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={null}>
       <br /><hr />
        <div className="button-container">
            <Button className='button'><a href={fandasturi}>fan dasturi</a></Button>
            <Button className='button'><a href={fansillabus}>fan sillabus</a></Button>
        </div>

    </Modal>
    </div>
  )
}
